import ready from "@/scripts/helpers/dom/ready";
import { initFaqSection } from "@/modules/section-faq";
import { initFooterSection } from "@/modules/section-footer";
import cookiePopup from "@/modules/popup-cookie";
import handleScroll from "@/modules/section-header";


ready( () => {
  initFaqSection();
  initFooterSection();
  setTimeout(() => {
    cookiePopup();
  }, 4000);
});